import React from "react";
import TitleStripe from "../../common/TitleStripe";
// (Opcional) Se usar Flowbite para Badge/Tooltip, importe aqui

export default function GastoEstimadoPF({ data }) {
  if (data?.statusRetorno != 1) return null;

  const {
    gastoTotal,
    comprometimentoRenda,
    nivelConfianca,
    cartaoCredito,
    parcelados,
    financiamentos,
  } = data?.gastoEstimado;

  const pctRange = (min, max) =>
    [min, max].every((v) => Number.isFinite(v))
      ? `${min.toFixed(0)}% – ${max.toFixed(0)}%`
      : "-";

  const pickPct = (min, max) => {
    if (![min, max].every((v) => Number.isFinite(v))) return null;
    return Math.round((min + max) / 2);
  };

  const compromPct = pickPct(
    comprometimentoRenda?.minPct,
    comprometimentoRenda?.maxPct
  );
  const ccPct = pickPct(
    cartaoCredito?.percentual?.minPct,
    cartaoCredito?.percentual?.maxPct
  );
  const parcPct = pickPct(
    parcelados?.percentual?.minPct,
    parcelados?.percentual?.maxPct
  );

  const Chip = ({ children, tone = "slate" }) => (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium
      bg-white border-${tone}-200 text-${tone}-700`}
    >
      {children}
    </span>
  );

  const Stat = ({
    title,
    value,
    note,
    gradient = "from-emerald-50 to-white",
  }) => (
    <div
      className={`rounded-2xl border p-4 shadow-sm bg-gradient-to-br ${gradient} border-slate-200`}
    >
      <p className="text-[11px] uppercase tracking-wide text-slate-500">
        {title}
      </p>
      <p className="mt-1 text-xl font-bold text-slate-800">{value ?? "-"}</p>
      {note && <p className="text-xs text-slate-500 mt-1">{note}</p>}
    </div>
  );

  const Progress = ({ label, minFmt, maxFmt, percent }) => (
    <div className="rounded-2xl border border-slate-200 p-4">
      <div className="flex items-center justify-between text-xs text-slate-500 mb-2">
        <span>{label}</span>
        <span className="font-medium text-slate-600">
          {Number.isFinite(percent) ? `${percent}%` : "-"}
        </span>
      </div>
      <div className="flex items-center justify-between text-[11px] text-slate-500 mb-1">
        <span>Min: {minFmt || "-"}</span>
        <span>Máx: {maxFmt || "-"}</span>
      </div>
      <div className="relative h-2 w-full bg-slate-200 rounded-full overflow-hidden">
        <div
          className="absolute inset-y-0 bg-emerald-500 transition-all"
          style={{ width: Number.isFinite(percent) ? `${percent}%` : "0%" }}
        />
      </div>
    </div>
  );

  const BoolPill = ({ ok, label }) => (
    <div
      className={`flex items-center gap-2 rounded-xl border px-3 py-2 text-sm
        ${
          ok
            ? "bg-emerald-50 border-emerald-200 text-emerald-700"
            : "bg-slate-50 border-slate-200 text-slate-500"
        }`}
    >
      <span className="text-base">{ok ? "✅" : "⛔️"}</span>
      <span>{label}</span>
    </div>
  );

  return (
    <div>
      {data?.statusRetorno == 1 && (
        <>
          {" "}
          <TitleStripe>Gasto Estimado</TitleStripe>
          <div className="w-full mx-auto rounded-2xl shadow-md border border-slate-200 p-4  bg-white mt-4">
            {/* Ribbon / título */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-2 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200 px-3 py-1 text-sm font-medium">
                  🔒 Nível de confiança:{" "}
                  <b>{nivelConfianca?.descricao || "-"}</b>
                </span>
              </div>
            </div>

            {/* KPIs principais */}
            <div className="grid grid-cols-3 gap-4 mb-5">
              <Stat
                title="Gasto Total"
                value={
                  gastoTotal?.type === "acima"
                    ? `Acima de ${gastoTotal?.thresholdFmt ?? "-"}`
                    : gastoTotal?.type === "ate"
                    ? `Até ${gastoTotal?.thresholdFmt ?? "-"}`
                    : gastoTotal?.type === "range"
                    ? `${gastoTotal?.minFmt ?? "-"} — ${
                        gastoTotal?.maxFmt ?? "-"
                      }`
                    : gastoTotal?.descricao || "-"
                }
                note="Estimativa mensal"
                gradient="from-amber-50 to-white"
              />
              <Stat
                title="No Cartão de Crédito"
                value={
                  cartaoCredito?.gasto?.type === "acima"
                    ? `≥ ${cartaoCredito?.gasto?.thresholdFmt ?? "-"}`
                    : cartaoCredito?.gasto?.type === "ate"
                    ? `≤ ${cartaoCredito?.gasto?.thresholdFmt ?? "-"}`
                    : cartaoCredito?.gasto?.type === "range"
                    ? `${cartaoCredito?.gasto?.minFmt ?? "-"} — ${
                        cartaoCredito?.gasto?.maxFmt ?? "-"
                      }`
                    : cartaoCredito?.gasto?.descricao || "-"
                }
                note={`Participação: ${pctRange(
                  cartaoCredito?.percentual?.minPct,
                  cartaoCredito?.percentual?.maxPct
                )}`}
                gradient="from-sky-50 to-white"
              />
              <Stat
                title="Em Parcelados"
                value={
                  parcelados?.gasto?.type === "acima"
                    ? `≥ ${parcelados?.gasto?.thresholdFmt ?? "-"}`
                    : parcelados?.gasto?.type === "ate"
                    ? `≤ ${parcelados?.gasto?.thresholdFmt ?? "-"}`
                    : parcelados?.gasto?.type === "range"
                    ? `${parcelados?.gasto?.minFmt ?? "-"} — ${
                        parcelados?.gasto?.maxFmt ?? "-"
                      }`
                    : parcelados?.gasto?.descricao || "-"
                }
                note={`Participação: ${pctRange(
                  parcelados?.percentual?.minPct,
                  parcelados?.percentual?.maxPct
                )}`}
                gradient="from-violet-50 to-white"
              />
            </div>

            {/* Barras de comprometimento */}
            <div className="grid grid-cols-3 gap-4 mb-6">
              <Progress
                label={`Comprometimento da Renda (${pctRange(
                  comprometimentoRenda?.minPct,
                  comprometimentoRenda?.maxPct
                )})`}
                minFmt={`${comprometimentoRenda?.minPct ?? "-"}%`}
                maxFmt={`${comprometimentoRenda?.maxPct ?? "-"}%`}
                percent={compromPct}
              />

              <Progress
                label={`% no Cartão (${pctRange(
                  cartaoCredito?.percentual?.minPct,
                  cartaoCredito?.percentual?.maxPct
                )})`}
                minFmt={`${cartaoCredito?.percentual?.minPct ?? "-"}%`}
                maxFmt={`${cartaoCredito?.percentual?.maxPct ?? "-"}%`}
                percent={ccPct}
              />

              <Progress
                label={`% em Parcelados (${pctRange(
                  parcelados?.percentual?.minPct,
                  parcelados?.percentual?.maxPct
                )})`}
                minFmt={`${parcelados?.percentual?.minPct ?? "-"}%`}
                maxFmt={`${parcelados?.percentual?.maxPct ?? "-"}%`}
                percent={parcPct}
              />
            </div>

            {/* Chips descritivos */}
            <div className="flex flex-wrap gap-2 mb-6">
              <Chip tone="amber">💸 Total: {gastoTotal?.descricao || "-"}</Chip>
              <Chip tone="sky">
                💳 Cartão: {cartaoCredito?.gasto?.descricao || "-"}
              </Chip>
              <Chip tone="violet">
                🧾 Parcelados: {parcelados?.gasto?.descricao || "-"}
              </Chip>
              <Chip tone="emerald">
                📊 Comprometimento: {comprometimentoRenda?.descricao || "-"}
              </Chip>
              <Chip tone="indigo">
                🔐 Confiança: {nivelConfianca?.descricao || "-"}
              </Chip>
            </div>

            {/* Financiamentos */}
            <div className="rounded-2xl border border-slate-200 p-4">
              <p className="text-[11px] uppercase tracking-wide text-slate-500 mb-3">
                Financiamentos & Obrigações
              </p>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
                <BoolPill
                  ok={!!financiamentos?.imobiliario}
                  label="Financiamento Imobiliário"
                />
                <BoolPill
                  ok={!!financiamentos?.veicular}
                  label="Financiamento Veicular"
                />
                <BoolPill
                  ok={!!financiamentos?.consorcios}
                  label="Consórcios"
                />
                <BoolPill
                  ok={!!financiamentos?.outrosParcelados}
                  label="Outros Parcelados"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
